import Link from "next/link";

import { FaFacebookSquare } from "react-icons/fa";
import { FaInstagram, FaLinkedin, FaXTwitter } from "react-icons/fa6";

import { SocialLinks } from "~/types/UserTypes";
import { cn } from "~/utils/fontsConfig";

export const SocialLinksComponent = ({
    socialLinks,
    className,
}: {
    socialLinks?: SocialLinks;
    className?: string;
}) => {
    return (
        <div className="flex items-center gap-3 ">
            {socialLinks?.x && (
                <Link
                    href={socialLinks.x}
                    rel="nofollow"
                    className="cursor-pointer"
                    target="_blank"
                >
                    <FaXTwitter className={cn("h-5 w-5", className)} />
                </Link>
            )}
            {socialLinks?.li && (
                <Link
                    href={socialLinks.li}
                    rel="nofollow"
                    className="cursor-pointer"
                    target="_blank"
                >
                    <FaLinkedin
                        className={cn("h-5 w-5 text-foreground", className)}
                        aria-hidden="true"
                    />
                </Link>
            )}
            {socialLinks?.ig && (
                <Link
                    href={socialLinks.ig}
                    rel="nofollow"
                    className="cursor-pointer"
                    target="_blank"
                >
                    <FaInstagram
                        className={cn(
                            "h-[1.4rem] w-[1.4rem] text-foreground",
                            className,
                        )}
                        aria-hidden="true"
                    />
                </Link>
            )}
            {socialLinks?.fb && (
                <Link
                    href={socialLinks.fb}
                    rel="nofollow"
                    className="cursor-pointer"
                    target="_blank"
                >
                    <FaFacebookSquare
                        className={cn("h-5 w-5 text-foreground", className)}
                        aria-hidden="true"
                    />
                </Link>
            )}
        </div>
    );
};
